<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="isEdit?'تعديل الفاتورة':'انشاء فاتورة'"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          <ok-date-time-picker
            v-model="form.subscribed_at"
            :label="$t('invoice.subscribed-at')"
            is-required
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-date-time-picker
            v-model="form.expires_at"
            :label="$t('page.expire-date')"
            is-required
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <general-templates-select
            v-model="form.package_id"
            is-required
            :label="$t('page.package')"
            :options="packages"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <general-templates-select
            v-model="form.referral_id"
            :label="$t('page.referral')"
            :options="referrals"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.period"
            :label="$t('invoice.period')"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.discount"
            :label="$t('invoice.discount')"
          />
        </b-col>
        <b-col md="6">
          <pages-auto-complete
            v-model="form.page_id"
          >
            {{ $t('invoice.page') }}
          </pages-auto-complete>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="form.paid"
            switch
          >
            {{ $t('invoice.paid') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.save') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkDateTimePicker from '@/@bya3/components/inputs/OkDateTimePicker'
import GeneralTemplatesSelect from '@/@bya3/components/inputs/GeneralTemplatesSelect'
import { mapGetters } from 'vuex'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import AdminInvoicesApi from '@/api/admin/invoices'
import PagesAutoComplete from '@/@bya3/components/inputs/PagesAutoComplete'

export default {
  name: 'ProcessInvoiceModal',
  components: {
    PagesAutoComplete,
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    GeneralTemplatesSelect,
    OkDateTimePicker,
    OkModal,
    BButton,
    BRow,
    BFormCheckbox,
    BCol,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      form: {

      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      packages: 'subscription/packages',
      referrals: 'auth/referrals',
    }),
    isEdit() {
      return !!this.invoice?.id
    },
  },
  watch: {
    invoice() {
      this.error = null
      this.setForm()
    },
  },
  mounted() {
    this.setForm()
  },
  methods: {
    async setForm() {
      if (this.isEdit) {
        this.form = { ...this.invoice }
        this.form.package_id = this.invoice?.package?.id
        this.form.paid = this.invoice?.paid === 1
      } else {
        this.form = {
          period: 1,
          subscribed_at: this.$moment().format('YYYY-MM-DD'),
          expires_at: this.$moment().add(1, 'M').format('YYYY-MM-DD'),
          cost: 0,
          commission: 0,
          paid: 0,
          discount: 0,
          package_id: null,
          referral_id: null,
          page_id: null,
        }
      }
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { ...this.form }
        if (this.isEdit) {
          form.invoice_id = form.id
          delete form.id
        }
        await AdminInvoicesApi.process(form).then(res => {
          if (res.error === 0) {
            this.$notifySuccess(res.message)
            this.$emit('updated')
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
